/**
 * Created by wuyanbin on 2019/7/17
 */
import React, { Component } from 'react';
import { Modal, Radio } from 'antd';
import { dispatch } from '@@/store';
import { connect } from '@souche-f2e/muji';
const mapStateToProps = (rootState) => ({
    buyer: rootState.buyer,
});
class ClearCodeModal extends Component {
    constructor(props) {
        super(props);
        this.handleOk = () => {
            const { value } = this.state;
            value ? dispatch.buyer.submitClearCode({}) : dispatch.buyer.TOGGLE_CLEAR_CODE_MODAL();
        };
        this.handleCancel = () => {
            dispatch.buyer.TOGGLE_CLEAR_CODE_MODAL();
        };
        this.onChange = (e) => {
            this.setState({
                value: e.target.value,
            });
        };
        this.state = {
            value: true,
        };
    }
    render() {
        const { clearCodeModal } = this.props.buyer;
        return (<Modal title="一键清空号牌确认" visible={clearCodeModal} onOk={this.handleOk} onCancel={this.handleCancel}>
        是否删除全部号牌：
        <Radio.Group onChange={this.onChange} value={this.state.value}>
          <Radio value={true}>是</Radio>
          <Radio value={false}>否</Radio>
        </Radio.Group>
      </Modal>);
    }
}
export default connect(mapStateToProps)(ClearCodeModal);
